import SmartIDService from './SmartIDService';

export default SmartIDService;
